module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/CentralJuvie-6_BW-c7eb1c2e3020cd33c314e3d5c7b5f143.jpg";